module.exports = __webpack_public_path__ + "static/flipchart-ec7625cbfbdca468dfc079cd97f81b3f.png";